define('BluePoint.WebinarForm.WebinarForm', 
	[
		'BluePoint.WebinarForm.WebinarForm.View'
	]
	, function (
		WebinarFormView
	) {
		'use strict';

		return {
			mountToApp: function mountToApp(container) {
				var Layout = container.getComponent('Layout');
				var environment = container.getComponent("Environment");
				var isactive = environment.getConfig('webinarform.isactive');

				if (isactive && Layout) {
					Layout.addChildView('Webinar.Form', function () {
						return new WebinarFormView({ application: container });
					});
				}
			}
		};
	});
